import React from 'react';
import { Tag, Wrapper } from 'components';
import { Appearance } from 'design';
import { GracePeriodTimeWorked, IDaySegmentGracePeriodPolicy } from 'types';

interface IGracePeriodItemProps {
  gracePeriodPolicy?: IDaySegmentGracePeriodPolicy;
}

const getDuration = (duration: number) => `Duration: ${duration} minute${duration !== 1 ? 's' : ''}`;
const getTimeWorked = (timeWorked: GracePeriodTimeWorked) => `Time Worked: ${timeWorked === GracePeriodTimeWorked.INCLUDE ? 'Included' : 'Excluded'}`;

export const GracePeriodItem: React.FC<IGracePeriodItemProps> = ({ gracePeriodPolicy }) => {
  if (!gracePeriodPolicy) return null;
  return (
    <Wrapper direction="row" alignItems="center">
      <Tag dataCy="duration-tag" label={getDuration(gracePeriodPolicy.segmentStart)} appearance={Appearance.SECONDARY} capitalize={false} />
      <Tag dataCy="time-worked-tag" label={getTimeWorked(gracePeriodPolicy.timeWorked)} appearance={Appearance.SECONDARY} />
    </Wrapper>
  );
};
